import type { ReactNode } from 'react'
import { createContext, useContext, useMemo, useState } from 'react'

interface AuthModalContextValue {
  isOpen: boolean
  openAuth: () => void
  closeAuth: () => void
}

const AuthModalContext = createContext<AuthModalContextValue | null>(null)

export function AuthModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)

  const value = useMemo(
    () => ({
      isOpen,
      openAuth: () => setIsOpen(true),
      closeAuth: () => setIsOpen(false),
    }),
    [isOpen],
  )

  return <AuthModalContext.Provider value={value}>{children}</AuthModalContext.Provider>
}

export function useAuthModal() {
  const ctx = useContext(AuthModalContext)
  if (!ctx) throw new Error('useAuthModal must be used within AuthModalProvider')
  return ctx
}
